// src/pages/Welcome/EmptyState.jsx
import React from 'react';
import { welcomeStyles } from './styles';
import { SearchIcon } from '../../components/Icons';
import { COLORS } from '../../constants';

const EmptyState = () => {
  return (
    <div style={welcomeStyles.emptyState}>
      <div style={{
        width: '120px',
        height: '120px',
        background: `linear-gradient(135deg, ${COLORS.primary}15 0%, ${COLORS.primary}05 100%)`,
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        margin: '0 auto 32px auto',
        border: `3px solid ${COLORS.primary}30`,
      }}>
        <SearchIcon size={48} color={COLORS.primary} />
      </div>
      <h3 style={welcomeStyles.emptyTitle}>No items found</h3>
      <p style={welcomeStyles.emptyText}>
        Try adjusting your search or filter criteria to discover amazing items from your fellow RedBirds. 
        New listings are added daily!
      </p>
    </div>
  );
};

export default EmptyState;